"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainUpdaterService = void 0;
const common_1 = require("@keplr-wallet/common");
const cosmos_1 = require("@keplr-wallet/cosmos");
const chain_validator_1 = require("@keplr-wallet/chain-validator");
const axios_1 = __importDefault(require("axios"));
class ChainUpdaterService {
    constructor(kvStore, communityChainInfoRepo) {
        this.kvStore = kvStore;
        this.communityChainInfoRepo = communityChainInfoRepo;
    }
    init(chainsService) {
        this.chainsService = chainsService;
    }
    replaceChainInfo(origin) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainIdentifier = cosmos_1.ChainIdHelper.parse(origin.chainId).identifier;
            let chainInfo = origin;
            const updatedChainInfo = yield this.kvStore.get("updated-chain-info/" + chainIdentifier);
            if (updatedChainInfo) {
                chainInfo = Object.assign(Object.assign({}, updatedChainInfo), { walletUrlForStaking: updatedChainInfo.walletUrlForStaking || origin.walletUrlForStaking, features: (() => {
                        var _a, _b;
                        const features = (_a = chainInfo.features) !== null && _a !== void 0 ? _a : [];
                        for (const f of (_b = updatedChainInfo.features) !== null && _b !== void 0 ? _b : []) {
                            if (!features.includes(f)) {
                                features.push(f);
                            }
                        }
                        return features;
                    })(), beta: origin.beta });
            }
            const local = yield this.kvStore.get(chainIdentifier);
            if (local) {
                chainInfo = Object.assign(Object.assign({}, chainInfo), {
                    chainId: local.chainId || chainInfo.chainId,
                    features: (() => {
                        var _a;
                        if (!local.features) {
                            return chainInfo.features;
                        }
                        const features = (_a = chainInfo.features) !== null && _a !== void 0 ? _a : [];
                        for (const add of local.features) {
                            if (!features.includes(add)) {
                                features.push(add);
                            }
                        }
                        return features;
                    })(),
                });
            }
            // Reduce the confusion from different coin type on ecosystem.
            // Unite coin type for all chain to 118 with allowing alternatives.
            // (If coin type is 60, it is probably to be compatible with metamask. So, in this case, do nothing.)
            if (chainInfo.bip44.coinType !== 118 && chainInfo.bip44.coinType !== 60) {
                chainInfo = Object.assign(Object.assign({}, chainInfo), { alternativeBIP44s: (() => {
                        var _a;
                        let res = (_a = chainInfo.alternativeBIP44s) !== null && _a !== void 0 ? _a : [];
                        if (res.find((c) => c.coinType === 118)) {
                            return res;
                        }
                        res = [...res, { coinType: 118 }];
                        return res;
                    })() });
            }
            const endpoints = yield this.getChainEndpoints(origin.chainId);
            return Object.assign(Object.assign({}, chainInfo), { rpc: endpoints.rpc || chainInfo.rpc, rest: endpoints.rest || chainInfo.rest });
        });
    }
    tryUpdateChainInfo(chainId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if ((yield this.chainsService.getChainInfo(chainId)).updateFromRepoDisabled) {
                return false;
            }
            try {
                const chainIdentifier = cosmos_1.ChainIdHelper.parse(chainId).identifier;
                let repoUpdated = false;
                try {
                    const res = yield axios_1.default.get(`/cosmos/${chainIdentifier}.json`, {
                        baseURL: `https://raw.githubusercontent.com/${this.communityChainInfoRepo.organizationName}/${this.communityChainInfoRepo.repoName}/${this.communityChainInfoRepo.branchName}`,
                    });
                    let chainInfo = res.data;
                    const fetchedChainIdentifier = cosmos_1.ChainIdHelper.parse(chainInfo.chainId)
                        .identifier;
                    if (chainIdentifier !== fetchedChainIdentifier) {
                        console.log(`The chainId is not valid.(${chainId} -> ${fetchedChainIdentifier})`);
                        return false;
                    }
                    const prevFetchedChainInfo = yield this.kvStore.get("updated-chain-info/" + chainIdentifier);
                    if (!prevFetchedChainInfo ||
                        common_1.sortedJsonByKeyStringify(prevFetchedChainInfo) !==
                            common_1.sortedJsonByKeyStringify(chainInfo)) {
                        repoUpdated = true;
                        chainInfo = yield chain_validator_1.validateBasicChainInfoType(chainInfo);
                        yield this.kvStore.set("updated-chain-info/" + chainIdentifier, chainInfo);
                        this.chainsService.clearCachedChainInfos();
                    }
                }
                catch (e) {
                    // Proceed logic event if fetching from github failed
                    console.log(e);
                }
                const updatedChainInfo = yield this.chainsService.getChainInfo(chainId);
                let chainIdUpdated = false;
                const chainIdFromRPC = yield this.checkChainIdFromRPC(updatedChainInfo.rpc);
                if (cosmos_1.ChainIdHelper.parse(chainIdFromRPC).identifier !== chainIdentifier) {
                    throw new Error(`Chain id is different from rpc: (expected: ${chainId}, actual: ${chainIdFromRPC})`);
                }
                if (updatedChainInfo.chainId !== chainIdFromRPC) {
                    chainIdUpdated = true;
                    const local = yield this.kvStore.get(chainIdentifier);
                    yield this.kvStore.set(chainIdentifier, Object.assign(Object.assign({}, local), { chainId: chainIdFromRPC }));
                }
                const toUpdateFeatures = yield chain_validator_1.checkChainFeatures(updatedChainInfo);
                const featuresUpdated = toUpdateFeatures.length !== 0;
                if (featuresUpdated) {
                    const local = yield this.kvStore.get(chainIdentifier);
                    yield this.kvStore.set(chainIdentifier, Object.assign(Object.assign({}, local), { features: [
                            ...new Set([...toUpdateFeatures, ...((_a = local === null || local === void 0 ? void 0 : local.features) !== null && _a !== void 0 ? _a : [])]),
                        ] }));
                }
                if (chainIdUpdated || featuresUpdated) {
                    this.chainsService.clearCachedChainInfos();
                }
                return repoUpdated || chainIdUpdated || featuresUpdated;
            }
            catch (e) {
                console.log(`Failed to try to update chain info for ${chainId}`, e);
            }
            return false;
        });
    }
    // This method is called on `ChainsService`.
    // TODO: Refactor
    clearUpdatedProperty(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kvStore.set(cosmos_1.ChainIdHelper.parse(chainId).identifier, null);
            yield this.kvStore.set("updated-chain-info/" + cosmos_1.ChainIdHelper.parse(chainId).identifier, null);
            this.chainsService.clearCachedChainInfos();
        });
    }
    // XXX: It is not conceptually valid that the function to set the rpc/rest endpoint of the chain exists in this service.
    //      However, in order to focus on adding feature rather than making a big change, the refactor is postponed later and the configuration of the rpc/rest endpoint is handled here.
    setChainEndpoints(chainId, rpc, rest) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kvStore.set("chain-info-endpoints/" + cosmos_1.ChainIdHelper.parse(chainId).identifier, {
                rpc,
                rest,
            });
            this.chainsService.clearCachedChainInfos();
            return yield this.chainsService.getChainInfos();
        });
    }
    getChainEndpoints(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            const saved = yield this.kvStore.get("chain-info-endpoints/" + cosmos_1.ChainIdHelper.parse(chainId).identifier);
            if (!saved) {
                return {
                    rpc: undefined,
                    rest: undefined,
                };
            }
            return saved;
        });
    }
    resetChainEndpoints(chainId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.kvStore.set("chain-info-endpoints/" + cosmos_1.ChainIdHelper.parse(chainId).identifier, null);
            this.chainsService.clearCachedChainInfos();
            return yield this.chainsService.getChainInfos();
        });
    }
    checkChainIdFromRPC(rpc) {
        return __awaiter(this, void 0, void 0, function* () {
            const statusResponse = yield axios_1.default.get("/status", {
                baseURL: rpc,
            });
            return statusResponse.data.result.node_info.network;
        });
    }
}
exports.ChainUpdaterService = ChainUpdaterService;
//# sourceMappingURL=service.js.map